import React, { useState } from 'react';
import styled from "styled-components"
import Modal from 'react-modal';

const customStyles = {
   content : {
      top                   : '55%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)',
      width                 : '80vw',
      height                : '80vh'
   }
};

Modal.setAppElement("#root")

const NewsModal = ({
   title,
   content,
   date
}) => {

   const [modalIsOpen,setIsOpen] = useState(false);
   const openModal = () =>  {
      setIsOpen(true);
   }
   const closeModal = () =>  {
      setIsOpen(false);
   }

   return (
      <>
         <div 
            onClick={openModal}
            className="news-list"
         >
            <h4>{title}</h4>
            <p>{date}</p>
         </div>
         <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
         >
            <NewsModalStyle>
               <h4 className="news-title">{title}</h4>
               <p className="news-content">{content}</p>
               <button 
                  onClick={closeModal}
                  className="close-btn"
                  >
                  <span></span>
                  <span></span>
               </button>
            </NewsModalStyle>
         </Modal>
      </>
   )
}

const NewsModalStyle = styled.div`
   position: relative;
   padding: 20px;
   z-index: 100;
   color: #5f5f5f;
   .news-title {
      font-size: 3rem;
   }
   .news-content {
      margin-top: 30px;
      font-size: 1.7rem;
      white-space: pre-line;
   }
   .close-btn {
      position: fixed;
      width: 30px;
      height: 30px;
      top: 20px;
      right: 20px;
      cursor: pointer;
      span {
         display: block;
         width: 30px;
         border-bottom: 1px solid;
         &:first-child {
            transform: rotate(45deg);
         }
         &:last-child {
            transform: rotate(-45deg);
         }
      }
   }
`

export default NewsModal